import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ListaComponent } from './lista/lista.component';
import {MatTabsModule} from '@angular/material/tabs'
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import {MatDialogModule} from '@angular/material/dialog';
import { Lista2Component } from './lista2/lista2.component';
import { VeicoliComponent } from './veicoli/veicoli.component';
import {MatTreeModule} from '@angular/material/tree';
import { Lista3Component } from './lista3/lista3.component';
import {MatListModule} from '@angular/material/list';
import { ModalLoginComponent } from './modal-login/modal-login.component';
import {MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {MatSnackBarModule } from "@angular/material/snack-bar";
import {CookieService} from 'ngx-cookie-service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ParcoComponent } from './parco/parco.component';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { SearchComponent } from './search/search.component'
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule } from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSortModule} from '@angular/material/sort';
import { BottomSheetSearchComponent } from './bottom-sheet-search/bottom-sheet-search.component';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { BolliComponent } from './bolli/bolli.component';
import { BottomSheetSearchBolliComponent } from './bottom-sheet-search-bolli/bottom-sheet-search-bolli.component';
import { MatPaginatorIntl } from '@angular/material';
import { ItalianPaginator } from './paginatorConfig';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    ListaComponent,
    Lista2Component,
    VeicoliComponent,
    Lista3Component,
    ModalLoginComponent,
    ParcoComponent,
    ModalConfirmComponent,
    SearchComponent,
    BottomSheetSearchComponent,
    BolliComponent,
    BottomSheetSearchBolliComponent
  ],
  entryComponents: [
    ModalLoginComponent,
    ModalConfirmComponent,
    BottomSheetSearchComponent,
    BottomSheetSearchBolliComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatToolbarModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    HttpClientModule,
    MatDialogModule,
    MatTreeModule,
    MatListModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    MatDatepickerModule,
    MatPaginatorModule ,
    MatBottomSheetModule,
    MatChipsModule,
    MatProgressBarModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: ItalianPaginator() },
    CookieService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
